import React, { useCallback } from 'react';
import {
  companyActions,
  companyFilterActions,
  companyFilters,
  companySelectors,
} from '../';
import { useDispatch, useSelector } from 'react-redux';
import useFilters from 'containers/Base/useFilters';
import LayoutWithMap from 'containers/Base/LayoutWithMap';
import PropTypes from 'prop-types';

const Companies = ({
  columns,
  filtersRequired,
  details,
  loading,
  //FormComponent,
}) => {
  const companiesListData = useSelector(state =>
    companySelectors.getCompanyList(state),
  );
  const totalEntries = useSelector(state =>
    companySelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state => companySelectors.getFilters(state));
  const forceRefresh = useSelector(state =>
    companySelectors.getForceRefresh(state),
  );
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchCompaniesList = useCallback(
    ({ filters, from }) =>
      dispatch(companyActions.fetchGridList({ filters, from })),
    [dispatch],
  );
  //---------------------------------------------------------------
  const onUpdate = filters => {
    dispatchFetchCompaniesList({
      filters,
    });
  };
  const fetchCompanies = from => {
    dispatchFetchCompaniesList({ filters: localFilterValues, from });
  };
  return (
    <LayoutWithMap
      header="Companies"
      //data
      cols={columns}
      data={companiesListData}
      totalEntries={totalEntries}
      onUpdate={onUpdate}
      fetchData={fetchCompanies}
      loading={loading}
      forceRefresh={forceRefresh}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={companyFilters()}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            companyFilterActions.setFilterKey({ key: true });
            companyFilterActions.setFilters({ filters });
          },
        })
      }
      //details panel
      DetailComponent={details}
    />
  );
};
Companies.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
};
export default Companies;
